import React from "react";
import './input.css'
import { FiSearch } from "react-icons/fi";
import { getSearchListing } from "../../api/actions";

const SearchInput = ({searchText,setSearchText,setSearchData,object,url}) => {
    const handleSubmit = (e) => {
        e.preventDefault()
        setSearchText(searchText)
        getSearchListing(setSearchData,object,url)
    }
    
    return(
        <div className="search-input-form mt-1">
           <form onSubmit={(e) => handleSubmit(e)}> 
            <input type="text" onChange={(e) => setSearchText(e.target.value)}/>
            <button className="search-form-submit-btn" type="submit">
                    <FiSearch  />
                  </button>
           </form>
        </div>
    )
}
export default SearchInput